// extracted by mini-css-extract-plugin
export default {"resume":"Resume_resume__1NBEx","education":"Resume_education__Q9UAL","languages":"Resume_languages__d2Psd","secs":"Resume_secs__uIEd+"};